import { CLIENTS } from "@/lib/sipl-content";

export default function Clients() {
  const items = [...CLIENTS, ...CLIENTS]; // duplicate for marquee
  return (
    <section
      id="clients"
      data-testid="clients-section"
      className="py-16 md:py-20 bg-white border-y border-sipl-line"
    >
      <div className="container-x text-center mb-10">
        <div className="text-sm uppercase tracking-[0.22em] text-sipl-secondary mb-3">
          Trusted by Government & Industry Leaders
        </div>
        <h2 className="font-heading text-2xl md:text-3xl text-sipl-primary font-medium">
          Empanelled across PSUs, ULBs & Indian Railways
        </h2>
      </div>

      <div className="marquee-mask overflow-hidden">
        <div className="flex gap-12 animate-marquee whitespace-nowrap">
          {items.map((c, idx) => {
            const Icon = c.icon;
            return (
              <div
                key={`${c.name}-${idx}`}
                data-testid={`client-${idx}`}
                className="flex items-center gap-3 text-slate-400 hover:text-sipl-primary transition-colors"
              >
                <Icon className="w-6 h-6" />
                <span className="font-heading font-semibold uppercase tracking-[0.18em] text-sm">
                  {c.name}
                </span>
                <span className="w-1 h-1 rounded-full bg-slate-300" />
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
